import Headspace from 'headspace';

(function ($) {
    /* Custom JS
	   Feel free to break into separate files if individual functions grow to excessive sizes.
	   Gulp will concatenate and minify separate files automatically.
	*/

    Headspace(document.getElementById('header'), {
        tolerance: 8, // default: 8
        showAtBottom: true,
    });

    /**
     * Add labels to sorting facets
     */
    $(document).on('facetwp-loaded', function () {
        $('.facetwp-facet').each(function () {
            var $facet = $(this);
            var facet_name = $facet.attr('data-name');
            var facet_label = FWP.settings.labels[facet_name];

            if (
                $facet.find('.facetwp-checkbox').length > 0 &&
                $facet.closest('.facet-wrap').length < 1 &&
                $facet.closest('.facetwp-flyout').length < 1
            ) {
                $facet.wrap('<div class="facet-wrap"></div>');
                $facet.before(
                    '<h6 class="facet-label">' + facet_label + ':</h6>'
                );
            }

            if (
                $facet.find('.facetwp-date').length > 0 &&
                $facet.closest('.facet-wrap').length < 1
            ) {
                $facet.wrap('<div class="facet-wrap"></div>');
                $facet.before(
                    '<h6 class="facet-label">' + facet_label + ':</h6>'
                );
            }
        });
    });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/scripts.js